import { AfterContentInit, Component, ElementRef, inject, input } from '@angular/core';

@Component({
  selector: 'app-dropdown-option',
  template: '<ng-content />',
})
export class DropdownOptionComponent implements AfterContentInit {
  private element = inject(ElementRef);

  readonly value = input.required<string>();
  private _label: string = '';

  get label(): string {
    return this._label;
  }

  ngAfterContentInit(): void {
    this._label = this.element.nativeElement.innerHTML;
  }
}
